import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Logout from '../views/Logout.vue'
import UserManagement from '../views/UserManagement.vue'
import store from '../store/index'
import Bridge from '../views/Bridge.vue'
import Unauthorized from '../views/Unauthorized.vue'

Vue.use(VueRouter)

function checkLoggedIn (to: any, from: any, next: any) {
  if( store.getters['auth/isLoggedIn'] ){
    if( store.getters['auth/getPermissions'].includes("Bridge Admin") || 
          store.getters['auth/getPermissions'].includes("Bridge Editor") ||  
            store.getters['auth/getPermissions'].includes("Bridge View")) {
        next();
    }
    else {
      next('/unauthorized');
    }
  }
  else {
    next('/login');
  }
}


function checkAdmin (to: any, from: any, next: any) {
  if( store.getters['auth/isLoggedIn'] &&  store.getters['auth/getPermissions'].includes("Bridge Admin")){
      next();
  }
  else {
    //relog
    next('/login');
  }
}

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/bridge',
    name: 'Bridge',
    component: Bridge,
    beforeEnter: checkLoggedIn,
  },
  {
    path: '/userManagement',
    name: 'userManagement',
    component: UserManagement,
    beforeEnter: checkAdmin,
  },

  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: Unauthorized
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if(to.name != 'Logout')
    store.dispatch('auth/getUser')
   //A Logged-in user can't go to login page again
  if (to.name == 'Login' && localStorage.getItem("token")) {
    router.push({
      name: 'bridge'
    })

    //the route requires authentication
  } else if (to.meta.authRequired) {

    if (!localStorage.getItem("token")) {
      //user not logged in, send them to login page
      router.push({
        name: 'login',
        query: {
          to: to.name
        }
      })

    }
  } 

  return next()
});

export default router
